module.exports = {
    "toolbarTip": "This toolbar will not appear in the final released project",
    "variableSettings": "Variable Settings",
    "previewTitle": "This is in Preview Mode",
    "varDlgTitle": "Environment Variable Settings",
    "varConsistsTips": "The client side var must consist of number, midline and word such as 1-CURR_YEAR while the server side var must consist of just word such as USER_ID",
    "save": "Save",
    "edit": "Edit",
    "delete": "Delete",
    "add": "Add",
    "addVar": "Add Variable",
    "value": "Value",
    "type": "Type",
    "scope": "Scope",
    "operations": "Operations",
    "cancel": "Cacel",
    "varUnstored": "There is variable unstored",
    "varName": "Variable Name",
    "dataBridgeError": "Data bridge response error. See more detail in console",
    "widgetDevError": "[Widget Dev Error] Invalid datasource id. ",
    "lpSyntaxError": "[Local Process Syntax Error] Local process function has syntax error: ",
    "lpExeError":"[Local Process Executing Error] Error occured when executing local process: ",
    "mockError":"[JSON Format Error] Invaild mock data: ",
    "staticError": "[JSON Format Error] Invaild JSON data in static datasource: ",
    "jsonpError": "jsonp calling failed. ",
    "httpJsonErr": "[JSON Format Error] Invaild JSON data responsed from http request: ",
    "customInterfaceErr": "[Dev Error] Error occured when request custom interface {{name}}",
    "dscallbackErr": "[Dev Error] Error occured when executing the callback after getting source data. See more details in console.",
    "standaloneMode": "Standalone Mode",
    "integratedMode": "Integrated Mode",
    "switchRole": "Switch Role",
    "cantViewStandalone": "Nothing can be viewed in standalone mode, please open a page first.",
    "unlimited": "Unlimited",
    "beforeExit": 'Are you sure to exit?',
    "logoutFailedMsg": 'Failed to logout, please close window directly.',
    "upBridgeTip": "You project can not be previewed normally unless upgrade the bridge to at least {{version}}. Follow this command to upgrade: npm install -g enhancer-data-bridge"
};


//////////////////
// WEBPACK FOOTER
// ./src/tools/i18n/locale.en.js
// module id = 6
// module chunks = 0 1 2